import {
  AuthorisationConsumer,
  CreditsConsumer,
  RequestProvider
} from '@shootsta/common-react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import TopupCreditsModalComponent from '../components/TopupCreditsModal';
import getContractsApi from '../api/getContracts';
import paymentCheckoutApi from '../api/paymentCheckout';
import { getFinanceBalance as getFinanceBalanceRequest } from '@core/shared/api/financeApi';
import { ApolloConsumer } from 'react-apollo';

interface TopupCreditsModal {
  visible: boolean;
  onClose: () => void;
}

function TopupCreditsModal({ visible, onClose }: TopupCreditsModal) {
  const flags = useFlags() || {};
  const financeLedgerEnabled = !!flags.financeLedgerEnabled;
  return (
    <ApolloConsumer>
      {(apolloClient) => (
        <AuthorisationConsumer>
          {({ selectedOrganisation: { organisationId, imageUrl } }) => (
            <CreditsConsumer>
              {({ state: { contractItemBalance } }) => {
                const requests: Record<string, any> = {
                  getContracts: getContractsApi(organisationId),
                  paymentCheckout: paymentCheckoutApi(organisationId)
                };
                if (financeLedgerEnabled) {
                  requests.getFinanceBalance = getFinanceBalanceRequest(
                    organisationId,
                    { silent: true }
                  );
                }
                return (
                  <RequestProvider requests={requests}>
                    {(api: any) => (
                      <TopupCreditsModalComponent
                        imageUrl={imageUrl}
                        organisationId={organisationId}
                        apolloClient={apolloClient}
                        visible={visible}
                        onClose={onClose}
                        contractItemBalance={contractItemBalance}
                        getContracts={api.getContracts}
                        paymentCheckout={api.paymentCheckout}
                        financeLedgerEnabled={financeLedgerEnabled}
                        getFinanceBalance={
                          financeLedgerEnabled ? api.getFinanceBalance : undefined
                        }
                      />
                    )}
                  </RequestProvider>
                );
              }}
            </CreditsConsumer>
          )}
        </AuthorisationConsumer>
      )}
    </ApolloConsumer>
  );
}

export default TopupCreditsModal;
